import ArchDiagram from './ArchDiagram';

export { ArchDiagram };
